interface SignalStatus {
  color: string;
  iconColor: string;
  text: string;
}

// EMS sensors report signal as a 0–100 quality index (sg >> 8), not dBm.
export const getRssiStatus = (rssi: string | null | undefined): SignalStatus => {
  if (!rssi) {
    return { color: 'text-gray-500 dark:text-gray-400', iconColor: 'text-gray-400', text: 'N/A' };
  }
  const v = parseFloat(rssi);
  if (v > 25) return { color: 'text-emerald-600 dark:text-emerald-400', iconColor: 'text-emerald-500 dark:text-emerald-400', text: `${rssi}%` };
  if (v >= 10) return { color: 'text-amber-600 dark:text-amber-400', iconColor: 'text-amber-500 dark:text-amber-400', text: `${rssi}%` };
  return { color: 'text-red-600 dark:text-red-400', iconColor: 'text-red-500 dark:text-red-400', text: `${rssi}%` };
};

export const getSignalStatus = (snr: string | null): SignalStatus => {
  if (!snr) {
    return {
      color: 'text-gray-500 dark:text-gray-400',
      iconColor: 'text-gray-400',
      text: 'N/A'
    };
  }

  const snrValue = parseFloat(snr);

  if (snrValue > 5) {
    return {
      color: 'text-emerald-600 dark:text-emerald-400',
      iconColor: 'text-emerald-500 dark:text-emerald-400',
      text: `${snr}dB`
    };
  }
  if (snrValue > 0) {
    return {
      color: 'text-amber-600 dark:text-amber-400',
      iconColor: 'text-amber-500 dark:text-amber-400',
      text: `${snr}dB`
    };
  }
  if (snrValue > -5) {
    return {
      color: 'text-orange-600 dark:text-orange-400',
      iconColor: 'text-orange-500 dark:text-orange-400',
      text: `${snr}dB`
    };
  }
  if (snrValue > -10) {
    return {
      color: 'text-red-600 dark:text-red-400',
      iconColor: 'text-red-500 dark:text-red-400',
      text: `${snr}dB`
    };
  }
  return {
    color: 'text-gray-500 dark:text-gray-400',
    iconColor: 'text-gray-400',
    text: `${snr}dB`
  };
};